import { Box, CircularProgress, Link } from '@mui/material';
import { RoutesType } from 'models/enum';
import TypographyWithI18N from 'pages/components/TypographyWithI18N';
import FriendRequest from 'pages/modules/notification/friendRequest';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { RootState } from 'store';
import { useAppDispatch, useAppSelector } from 'store/hook';
import { setGuestClickAction } from 'store/guestModeSlice';
import { colors } from 'styles/colors';
import ChatsScreen from 'pages/modules/chats/chatsScreen';
import PrivacyPolicy from 'pages/authentication/privacyPolicy';
import TermsOfUse from 'pages/authentication/termsOfUse';
import { LogoIcon } from 'assets';
import AdminButton from '../components/button';
import { appAccountValidation, swmAccountValidation } from 'utilities/authTokenValidation';
import About4um from 'pages/authentication/About4um';
import Trendings from 'pages/modules/trendings/trendings';

interface IRightSidePanel {
  isLoggedIn?: boolean;
}
const RightSidePanel = ({ isLoggedIn }: IRightSidePanel) => {
  const navigate: any = useNavigate();
  const location = useLocation();
  const { isFriendData }: any = useAppSelector(
    (state: RootState) => state.friendList
  );

  const pathnames = location.pathname.split('/').filter((x) => x)[0];
  const [active, setActive] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);
  const { isChatEnabled }: any = useAppSelector(
    (state: RootState) => state.featureFlag
  );

  const [openPrivacyModal, setOpenPrivacyModal] = useState(false);
  const [openTermsModal, setOpenTermsModal] = useState(false);
  const currentYear = new Date().getFullYear();
  const dispatch = useAppDispatch();
  const { userProfile, authToken }: any = useAppSelector(
    (state: RootState) => state.userAuth
  );
  const isAppAccount = appAccountValidation?.(authToken ?? null);
  const isSWMAccount = swmAccountValidation?.(authToken ?? null);
  const path = location.pathname + location.search;

  const createAccountSignIn = (navigateTo: string) => {
    dispatch(
      setGuestClickAction({
        guestMode: true,
        navigateTo: navigateTo,
        menu: navigateTo,
        redirectTo: path,
        action: path === '/' ? navigateTo : 'other',
        actionItem: null
      })
    );
    navigate('/signin');
  };

  useEffect(() => {
    // if (isFriendData && pathnames === RoutesType.notification) {
      setLoader(true);
      setTimeout(() => {
        setLoader(false);
      }, 1000);
    // }
  }, [isFriendData]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        width: '-webkit-fill-available',
        overflow: 'hidden'
      }}
    >
      {
      isLoggedIn ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            width:'-webkit-fill-available',
            overflow: 'hidden'
          }}
        >
          <Box
            sx={{
              mt: 1,
              flex: 1,
              overflowY: 'auto',
              pr: 1,
              minHeight: 0
            }}
          >
            <Trendings />
          </Box>

          {pathnames !== 'chat' && !(isAppAccount || isSWMAccount) && (<Box
              sx={{
                background: colors.background.approxAliceBlue,
                mt: 2,
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                flexShrink: 0
              }}
            >
              <ChatsScreen />
            </Box>
          )}
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            textAlign: 'center',
            width:'-webkit-fill-available',
            overflow: 'hidden'
          }}
        >
          <Box
            sx={{
              alignItems: 'center',
              paddingTop: '20px',
              margin: '20px auto',
              cursor: 'pointer',
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            }}
          >
        <Box sx={{marginRight:{md:'30px', lg:'auto'}}}>
        <LogoIcon style={{padding: '10px auto'}} />
            </Box>
            <TypographyWithI18N
          i18nKey={"Join the conversation"}
              sx={{
                py: 2,
                mt: 2,
                fontSize: '24px',
                fontWeight: 600,
                color: colors.text.primaryBlack
              }}
            />
            <Box>
              <AdminButton
                title='Create Account'
                onClick={() => createAccountSignIn('create-account')}
                variant='outlined'
                role='presentation'
                aria-label={` Button Press Enter to Create Account`}
                sxProps={{
                  height: 44,
                  '&.MuiButton-outlined': {
                    border: `1px solid ${colors.text.primaryTheme}`,
                    background: colors.text.primaryTheme,
                color: colors.text.primaryWhite,
              },
                }}
              />
              <AdminButton
                title='Log in'
                onClick={() => createAccountSignIn('sign-in')}
                variant='outlined'
                role='presentation'
                aria-label={` Button Press Enter to Log in`}
                sxProps={{
                  height: 44,
                  ml: '12px',
                  '&.MuiButton-outlined': {
                    border: `1px solid ${colors.text.approxVeryLightGrey}`,
                    background: colors.text.primaryWhite,
                color: colors.text.darkGray,
                  },
              mt: { md: '15px', lg:'initial' },
              width: { md: '145px', lg:'initial' },
              mr: { md: '10px', lg:'initial' },
                }}
              />
            </Box>
          </Box>

      <Box sx={{ 
              margin: '16px 0',
              display: 'flex',
              alignItems: 'center',
              fontSize: '12px',
              flexShrink: 0
      }}>
            <Link
              className='bodyText'
              sx={{
                color: colors.text.primaryTheme,
                cursor: 'pointer',
                fontSize: '11px !important'
              }}
              underline='none'
              onClick={() => {
                setOpenTermsModal(true);
                setOpenPrivacyModal(false);
              }}
            >
              Terms of Service
            </Link>
            <span>&nbsp;|&nbsp;</span>
            <Link
              className='bodyText'
              sx={{
                color: colors.text.primaryTheme,
                cursor: 'pointer',
                fontSize: '11px !important'
              }}
              underline='none'
              onClick={() => {
                setOpenTermsModal(false);
                setOpenPrivacyModal(true);
              }}
            >
              Privacy Policy
            </Link>
            <span>&nbsp;|&nbsp;</span>
            <Link
              className='bodyText'
              sx={{
                color: colors.text.primaryTheme,
                cursor: 'pointer',
                fontSize: '11px !important'
              }}
              underline='none'
              onClick={() => navigate('/aboutus')}
            >
              About 4um
            </Link>
            <span>&nbsp;|&nbsp;</span>
            <TypographyWithI18N
              className='metadata'
              i18nKey={`© ${currentYear} 4um`}
            />
          </Box>
        </Box>
      )}

      {openPrivacyModal && (
        <PrivacyPolicy openModal={openPrivacyModal} setOpenModal={setOpenPrivacyModal} />
      )}
      {openTermsModal && (
        <TermsOfUse openModal={openTermsModal} setOpenModal={setOpenTermsModal} />
      )}
    </Box>
  );
};

export default RightSidePanel;